export const environment = {
  production: false,
  serverUrl: 'https://periscope-api.dnvsspl.com/v1/',
  imageUrl: 'https://periscope-api.dnvsspl.com/v1/',
  pdfUrl: 'https://periscope-api.dnvsspl.com/v1/',


  // serverUrl: 'https://dnv-api.visitorbridge.in/v1/',
  // imageUrl: 'https://dnv-api.visitorbridge.in/v1/',
  // pdfUrl: 'https://dnv-api.visitorbridge.in/v1/',
};
